import { StateSchema } from 'app/config/storeConfig/types';

export const getAppLoadingState = (state: StateSchema): boolean => Boolean(state.app.loadingCount);
